module.exports = __webpack_public_path__ + "img/funList.386f3410.png";